import { openErrorToaster } from 'helpers/toaster.helpers'
import { handleSessionExpired } from 'helpers/session.helpers'
import { getTranslatedErrorMessage, getTranslation } from 'helpers/translations.helpers'
import errorMessages from 'network/messages/errorMessages'
import store from 'index'
import { stopLoader } from 'redux-thunk/redux/slices/loader.slice'

const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again.'

export const errorHandler = (error) => {
  const response = error?.response
  const config = response?.config
  const errors = response?.data?.errors
  const firstError = Array.isArray(errors) && errors[0] ? errors[0] : null

  if (config?.loader) {
    store.dispatch(stopLoader(config.loader))
  }

  if (!response) {
    openErrorToaster({ message: getTranslation(errorMessages.internalServerError) })
    return Promise.reject([{ description: DEFAULT_ERROR_MESSAGE }])
  }

  if (response.status === 500) {
    openErrorToaster({ message: getTranslation(errorMessages.internalServerError) })
    return Promise.reject(errors || [{ description: DEFAULT_ERROR_MESSAGE }])
  }

  if (response.status === 401) {
    openErrorToaster({ message: getTranslation(errorMessages.unAuthorized) })
    handleSessionExpired({ showToast: false })
    return Promise.reject(errors || [{ description: DEFAULT_ERROR_MESSAGE }])
  }

  if (firstError) {
    const errorMessage = firstError.description
    const apiErrorCode = firstError.errorCode
    const displayMessage = errorMessage || getTranslatedErrorMessage(Number(apiErrorCode))
    openErrorToaster({ message: displayMessage })
  } else {
    openErrorToaster({ message: DEFAULT_ERROR_MESSAGE })
  }

  return Promise.reject(errors || [{ description: DEFAULT_ERROR_MESSAGE }])
}
